import i18n from 'i18next';
import { equipmentResources } from '../features/equipment/registry';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import koCommon from '../locales/ko/common.json';
import koLogin from '../locales/ko/login.json';
import koApp from '../locales/ko/app.json';

import enCommon from '../locales/en/common.json';
import enLogin from '../locales/en/login.json';
import enApp from '../locales/en/app.json';

import trCommon from '../locales/tr/common.json';
import trLogin from '../locales/tr/login.json';
import trApp from '../locales/tr/app.json';

import ptCommon from '../locales/pt/common.json';
import ptLogin from '../locales/pt/login.json';
import ptApp from '../locales/pt/app.json';

import hiCommon from '../locales/hi/common.json';
import hiLogin from '../locales/hi/login.json';
import hiApp from '../locales/hi/app.json';

import esCommon from '../locales/es/common.json';
import esLogin from '../locales/es/login.json';
import esApp from '../locales/es/app.json';

import deCommon from '../locales/de/common.json';
import deLogin from '../locales/de/login.json';
import deApp from '../locales/de/app.json';

import zhCommon from '../locales/zh/common.json';
import zhLogin from '../locales/zh/login.json';
import zhApp from '../locales/zh/app.json';

import itCommon from '../locales/it/common.json';
import itLogin from '../locales/it/login.json';
import itApp from '../locales/it/app.json';

import plCommon from '../locales/pl/common.json';
import plLogin from '../locales/pl/login.json';
import plApp from '../locales/pl/app.json';

import csCommon from '../locales/cs/common.json';
import csLogin from '../locales/cs/login.json';
import csApp from '../locales/cs/app.json';

import ukCommon from '../locales/uk/common.json';
import ukLogin from '../locales/uk/login.json';
import ukApp from '../locales/uk/app.json';

import uzCommon from '../locales/uz/common.json';
import uzLogin from '../locales/uz/login.json';
import uzApp from '../locales/uz/app.json';

import {
  DEFAULT_LANGUAGE,
  LANGUAGE_STORAGE_KEY,
  SUPPORTED_LANGUAGE_CODES,
  getLanguageConfig,
} from './languages';

const resources = {
  ko: {
    common: koCommon,
    login: koLogin,
    app: koApp,
  },
  en: {
    common: enCommon,
    login: enLogin,
    app: enApp,
  },
  tr: {
    common: trCommon,
    login: trLogin,
    app: trApp,
  },
  pt: {
    common: ptCommon,
    login: ptLogin,
    app: ptApp,
  },
  hi: {
    common: hiCommon,
    login: hiLogin,
    app: hiApp,
  },
  es: {
    common: esCommon,
    login: esLogin,
    app: esApp,
  },
  de: {
    common: deCommon,
    login: deLogin,
    app: deApp,
  },
  zh: {
    common: zhCommon,
    login: zhLogin,
    app: zhApp,
  },
  it: {
    common: itCommon,
    login: itLogin,
    app: itApp,
  },
  pl: {
    common: plCommon,
    login: plLogin,
    app: plApp,
  },
  cs: {
    common: csCommon,
    login: csLogin,
    app: csApp,
  },
  uk: {
    common: ukCommon,
    login: ukLogin,
    app: ukApp,
  },
  uz: {
    common: uzCommon,
    login: uzLogin,
    app: uzApp,
  },

};

// Each registered machine contributes its own translations.
for (const [language, resource] of Object.entries(equipmentResources)) {
  if (resources[language]) resources[language].equipment = resource;
}

function updateDocumentLanguage(languageCode) {
  if (typeof document === 'undefined') {
    return;
  }

  const languageConfig =
    getLanguageConfig(languageCode);

  document.documentElement.lang =
    languageConfig?.htmlLang ||
    DEFAULT_LANGUAGE;
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    initImmediate: false,
    lng: typeof document === 'undefined' ? DEFAULT_LANGUAGE :
      document.getElementById('root')?.dataset.ssgLanguage || undefined,

    supportedLngs:
      SUPPORTED_LANGUAGE_CODES,

    fallbackLng: DEFAULT_LANGUAGE,

    load: 'languageOnly',
    nonExplicitSupportedLngs: true,

    ns: ['common', 'login', 'app', 'equipment'],
    defaultNS: 'common',
    fallbackNS: 'common',

    detection: {
      order: [
        'localStorage',
        'navigator',
      ],

      lookupLocalStorage:
        LANGUAGE_STORAGE_KEY,

      caches: typeof document === 'undefined' || document.getElementById('root')?.dataset.ssgLanguage ? [] : ['localStorage'],
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },

    returnNull: false,
    returnEmptyString: false,

    debug:
      process.env.REACT_APP_I18N_DEBUG ===
      'true',
  });

i18n.on(
  'languageChanged',
  updateDocumentLanguage,
);

updateDocumentLanguage(
  i18n.resolvedLanguage ||
    i18n.language ||
    DEFAULT_LANGUAGE,
);

export default i18n;
export function restoreBrowserLanguage() {
  i18n.services.languageDetector.options.caches = ['localStorage'];
  return i18n.changeLanguage();
}
